import React from "react";
import UnipAvatarEditor from "../../../avatar-editor/UnipAvatarEditor";
import UserCoordonneesEditForm from "./UserCoordonneesEditForm";
import {ValidatorForm} from "react-material-ui-form-validator";
import {useDispatch} from "react-redux";
import {toggleLoading} from "../../../../store/slices/loadingSlice";
import UserService from "../../../../api/extranet/services/UserService";
import {useKeycloak} from "@react-keycloak/web";
import DOMHelper from "../../../../helpers/DOMHelper";
import useMessageNotifier from "../../../../helpers/hooks/component/useMessageNotifier";
import { updateUserInformations } from "../../../../store/slices/accountSlice";
import StringHelper from "../../../../helpers/StringHelper";
import DefaultLayout from "../../../layout/DefaultLayout";
import SubCard from '../../../berry/ui-component/cards/SubCard';

import {
    Button,
    Divider,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Typography
} from '@mui/material';

import { gridSpacing } from '../../../../store/appConstant';
function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
}

const PersonnalDataEditForm = ({account, editMode, setEditMode, ...props}) => {


    const mainForm = React.useRef();
    const dispatch = useDispatch();
    const { keycloak } = useKeycloak();
    const { showMessage } = useMessageNotifier();
    const [state, setState] = React.useState({
        userAvatar: null,
        displayName: '',
        avatarColor: '',
        address: '',
        addressExtend: '',
        postalCode: '',
        city: '',
        phone: '',
        firstname: '',
        lastname: '',
        birthdate: '',
        ssNum: '',
        extranetUuid: '',
        type: ''
    });

    React.useEffect(() => {

        setState({
            userAvatar: account.user?.avatar ,
            displayName: account.user?.displayName ,
            avatarColor: account.user?.avatarColor ,
            address: account.profil.address,
            addressExtend: account.profil.addressExtend,
            postalCode: account.profil.postalCode,
            city: account.profil.city,
            phone: account.profil.phone,
            firstname: account.profil.firstname,
            lastname: account.profil.lastname,
            birthdate: account.profil.birthdate,
            ssNum: account.profil.ssNum,
            extranetUuid: account.user?.extranetUuid,
            type: account.user?.type,

            prevAvatar: account.user?.avatar,
            prevAddress: account.profil.address,
            prevAddressExtend: account.profil.addressExtend,
            prevPostalCode: account.profil.postalCode,
            prevCity: account.profil.city,
            prevPhone: account.profil.phone,
        })
    }, [account])

    const handleChange = (event) => {
        setState(prevState => ({
            ...prevState,
            [event.target.name] : event.target.value
        }))
    }
    const setNewUserAvatar = (newUserImage) => {
        setState(prevState => ({
            ...prevState,
            userAvatar: newUserImage
        }))
    }
    const formatDate = (dateString) => {
        if (!dateString) {
            console.warn("Received undefined or null dateString:", dateString);
            return ""; // Return an empty string or any default value you prefer
        }
        const [year, month, day] = dateString.split('-');
        return `${day}-${month}-${year}`;
    };
    const rows = [
        createData('Prénom', ':', state.firstname),
        createData('Nom', ':', state.lastname),
        createData('Date de naissance', ':', formatDate(state.birthdate)),
        createData('Numéro de sécurité sociale', ':', StringHelper.formatSSNum(state.ssNum))
    ];
    const renderWithEditMode = () => {

        return   <DefaultLayout>
                        <UnipAvatarEditor
                            userAvatar={state.userAvatar}
                            displayName={state.displayName}
                            avatarColor={state.avatarColor}
                            setNewUserAvatar={setNewUserAvatar}
                            editMode={editMode}
                            setEditMode={setEditMode}
                        />
                </DefaultLayout>
    }
    const handleSubmit = () => {
        mainForm.current.isFormValid(false)
            .then(async (valid) => {
                if (valid) {
                    const resultCall = await callUserUpdate();
                    if (resultCall.code === 200) {
                        // update state on store
                        dispatch(updateUserInformations({
                            postalCode : state.postalCode,
                            phone : state.phone,
                            city: state.city,
                            address: state.address,
                            addressExtend : state.addressExtend,
                            userAvatar : state.userAvatar
                        }))
                        showMessage(resultCall.message, 'success');
                    } else {
                        // show error message
                        showMessage(resultCall.message, 'error');
                    }
                } else {
                    DOMHelper.scrollToError();
                }
            })
        ;
    }

    const callUserUpdate = async () => {
        switch (state.type) {
            case "ASSURE":
            case "ENTREPRISE":
                dispatch(toggleLoading());
                const data = {
                    userAvatar: state.userAvatar,
                    address: state.address,
                    addressExtend: state.addressExtend,
                    postalCode: state.postalCode,
                    city: state.city,
                    phone: state.phone
                }
                const resultUpdate = await UserService.updateUserInformations(keycloak.token,state.extranetUuid,data)
                dispatch(toggleLoading());
                return resultUpdate;
            default:
                console.warn(state.type)
                console.warn("Ce type de profil n'est pas encore planifié !")
                return false
        }
    }

    const buttonDisabled = () => {

        if (state.userAvatar !== state.prevAvatar) {
            return false
        }
        if (state.address !== state.prevAddress) {
            return false
        }
        if (state.addressExtend !== state.prevAddressExtend) {
            return false
        }
        if (state.postalCode !== state.prevPostalCode) {
            return false
        }
        if (state.city !== state.prevCity) {
            return false
        }
        if (state.phone !== state.prevPhone) {
            return false
        }
        return true
    }

    return <DefaultLayout>
        <Grid container spacing={gridSpacing} sx={{ marginBottom : '50px'}}>
        <Grid item lg={6} xs={12}>
            <Grid container spacing={gridSpacing}>
                <Grid item xs={12}>
                    <SubCard
                        title="Mon identité"
                    >
                        <Grid container spacing={2}>
                            <Divider sx={{ pt: 1 }} />
                            <Grid item xs={12}>
                                <TableContainer>
                                    <Table
                                        sx={{
                                            '& td': {
                                                borderBottom: 'none'
                                            }
                                        }}
                                        size="small"
                                    >
                                        <TableBody>
                                            {rows.map((row) => (
                                                <TableRow key={row.name}>
                                                    <TableCell variant="head">{row.name}</TableCell>
                                                    <TableCell>{row.calories}</TableCell>
                                                    <TableCell>{row.fat}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                    </SubCard>
                </Grid>
            </Grid>
        </Grid>
        <Grid item lg={6} xs={12}>
            {renderWithEditMode()}
        </Grid>
            <Grid item lg={12} xs={12} >
                 <Grid container spacing={gridSpacing}>
                    <Grid item xs={12}>
                        <SubCard
                            title="Mon adresse postale"
                        >
                            <ValidatorForm
                                        ref={mainForm}
                                        onSubmit={handleSubmit}
                                        onError={() => console.error('onError')}
                                    >
                                                    <UserCoordonneesEditForm
                                                        address={state.address}
                                                        addressExtend={state.addressExtend}
                                                        postalCode={state.postalCode}
                                                        city={state.city}
                                                        phone={state.phone}
                                                        handleChange={handleChange}
                                                    />

                                {/* <Button variant="contained" type="submit" color="secondary">
                                            Enregistrer
                                        </Button> */}

                                    </ValidatorForm>
                        </SubCard>
                    </Grid>
                </Grid>
            </Grid>
    </Grid>

    </DefaultLayout>

}


export default PersonnalDataEditForm
